import { ensureLayerOnMap, setLayerVisible } from '@/map/mapStore';
import { findLayer } from '@/map/layers/registry';
import type { Tool } from './types';

type Input = { layer_id: string; visible: boolean };

export const viewToggleLayer: Tool<Input> = {
  name: 'view_toggle_layer',
  description:
    'Add a configured layer to the map (visible=true) or hide/remove (visible=false). Other tools auto-add their target layer; only call this when the user explicitly wants to change visibility.',
  input_schema: {
    type: 'object',
    properties: {
      layer_id: { type: 'string' },
      visible: { type: 'boolean' },
    },
    required: ['layer_id', 'visible'],
    additionalProperties: false,
  },
  execute: async ({ layer_id, visible }) => {
    if (!findLayer(layer_id)) throw new Error(`Unknown layer id: "${layer_id}"`);
    if (visible) await ensureLayerOnMap(layer_id);
    setLayerVisible(layer_id, visible);
    return { layer_id, visible };
  },
};
